import { render } from "./PublicPersonalities.vue?vue&type=template&id=555e3fda&scoped=true"
import script from "./PublicPersonalities.vue?vue&type=script&lang=js"
export * from "./PublicPersonalities.vue?vue&type=script&lang=js"

import "./PublicPersonalities.vue?vue&type=style&index=0&id=555e3fda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-555e3fda"]])

export default __exports__